import React from 'react';
import DetectTouch from '../partials/global/DetectTouch';
import ViewportFix from '../partials/global/ViewportFix';
import Cover from '../partials/global/Cover';
import Scrolled from '../partials/global/Scrolled';
import Enquire from '../partials/global/Enquire';
import Header from '../partials/global/Header';
import Page from '../partials/page/Page';
import Projects from '../partials/project/Projects';
import ProjectTemplate from '../partials/projects/ProjectTemplate';
import Project from '../partials/project/Project';
import News from '../partials/news/News';
import {Provider} from '../context/Context'
import { ParallaxProvider } from 'react-scroll-parallax';

const TplIndex = (props) => {  
		
	let block = null;
	
	if (props.match.path === '/project/:slug') {
		block = <Project></Project>;
	} else if (props.match.path === '/projects/:slug') {
		block = <ProjectTemplate></ProjectTemplate>;
	} else if (props.match.path === '/projects/') {
		block = <Projects></Projects>;
	} else if (props.match.path === '/news/') {
		block = <News></News>;
	} else if (props.match.path === '/type/:slug') {
		block = <Projects></Projects>;
	} else if (props.match.path === '/:slug') {
		block = <Page></Page>;
	} else if (props.match.path === '/') {
		block = <Page></Page>;
	}
    
    if (block) {
		return (
			<Provider router={props}>
				<DetectTouch></DetectTouch>
				<ViewportFix></ViewportFix>
				<Cover></Cover>
				<Header></Header>
				<Enquire></Enquire>
				<ParallaxProvider>
					<div className="c-site-wrapper">
						
						{ block }
					</div>
				</ParallaxProvider>
				<Scrolled></Scrolled>
			</Provider>
		)    
	} else {
		return null;
	}
}
export default TplIndex